module.exports = __webpack_public_path__ + "img/LAST_ACTIVITIES.b8b1fe18.svg";